import React, {useState} from 'react';
import './success.scss';

import IDEA_ICON from "assets/icons/idea_icon.png";
import EDUCATION_ICON from "assets/icons/education_icon.png";
import MENTOR_ICON from "assets/icons/mentor_icon.png";
import SUCCESS_IMAGE from 'assets/business-education-assets/be_success_image.png';
import {Accordion, Button, HeadingElement} from 'components';
import {Panel} from 'models';
import {useNavigate} from "react-router-dom";

const Success = () => {
    const navigate = useNavigate()
    const [selectedPermissions] = useState<Panel[]>([
        {
            id: 0,
            name: "Promotion of Entrepreneurship",
            image: IDEA_ICON,
            description: "The promotion of entrepreneurship and mentoring of members."
        },
        {
            id: 1,
            name: "Mentorship & Training",
            image: MENTOR_ICON,
            description: "The facilitation of technical advice, training, consultancy and trade services, employing modern technology."
        },
        {
            id: 2,
            name: "Education & Development",
            image: EDUCATION_ICON,
            description: "The SBAJ embraces continuous learning and improvement, therefore, we make it our duty to provide educational material to all our members."
        },
        // {
        //     id: 3,
        //     name: "Provide Business Education",
        //     image: EDUCATION_ICON,
        //     description: "The facilitation of technical advice, training, consultancy and trade services, employing modern technology"
        // }
    ]);
    return (
        <div className="success" id={'success'}>
            <div className="success_wrapper max">
                <div className="success_wrapper_left">
                    <img src={SUCCESS_IMAGE} alt=""/>
                    <div className="success_wrapper_left_content">
                        <h1>Did you know?</h1>
                        <p>Small Business Association of Jamaica, provides practical business advice and education to
                            small businesses in Jamaica,
                            through the facilitation of technical advice, training, consultancy and trade services,
                            employing modern technology.</p>
                        <Button text={'Learn More'} type={'primary'} onclick={() => navigate('/about')}/>
                    </div>
                </div>

                <div className="success_wrapper_right">
                    <div className="success_wrapper_right_content">

                        <HeadingElement/>
                        <h1>Here to help you become successful</h1>
                        <p>The mission of the Small Business Association of Jamaica, is to support the Jamaican economy by
                            developing the small business
                            sector through:</p>
                    </div>
                    <div className="success_wrapper_right_missions">
                        <Accordion panels={selectedPermissions}/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Success;
